import { B2B_PACKAGE_MANAGEMENT, PARTNER_MANAGEMENT } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { IB2CPartnerManagementRepository } from "features/partnerManagement/domain/repositories/IB2CPartnerManagementRepository";
import { injectable } from "tsyringe";
import { B2CCreatePartnerRequestModel } from "./model/b2cProvider/create/CreatePartnerRequestModel";
import { B2CCreatePartnerResponseModel } from "./model/b2cProvider/create/CreatePartnerResponseModel";
import { B2CPartnerManagementDetailResponseModel } from "./model/b2cProvider/detail/PartnerManagementDetailResponseModel";
import { B2CPartnerManagementRequestModel } from "./model/b2cProvider/PartnerManagementRequestModel";
import { B2CPartnerManagementResponseModel } from "./model/b2cProvider/PartnerManagementResponseModel";
import { B2CUpdatePartnerRequestModel } from "./model/b2cProvider/update/UpdatePartnerRequestModel";

@injectable()
export class B2CPartnerManagementImpl implements IB2CPartnerManagementRepository {
  async getList(
    params: B2CPartnerManagementRequestModel,
  ): Promise<ListBaseApiResponseModel<B2CPartnerManagementResponseModel>> {
    return await client?.get(PARTNER_MANAGEMENT?.LIST, params);
  }

  async getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<B2CPartnerManagementDetailResponseModel>> {
    return await client?.get(PARTNER_MANAGEMENT?.DETAIL, params);
  }

  async getB2BList(
    params: B2CPartnerManagementRequestModel,
  ): Promise<ListBaseApiResponseModel<B2CPartnerManagementResponseModel>> {
    return await client?.get(B2B_PACKAGE_MANAGEMENT.B2B_PARTNER_LIST, params);
  }

  async updatePartner(
    body: B2CUpdatePartnerRequestModel,
  ): Promise<BaseApiResponseModel<B2CPartnerManagementDetailResponseModel>> {
    return await client?.put(`${PARTNER_MANAGEMENT?.UPDATE}`, body);
  }

  async createPartner(
    body: B2CCreatePartnerRequestModel,
  ): Promise<BaseApiResponseModel<B2CCreatePartnerResponseModel>> {
    return await client?.post(PARTNER_MANAGEMENT?.CREATE, body);
  }

  async deletePartner(params: {
    code: string;
  }): Promise<BaseApiResponseModel<B2CPartnerManagementResponseModel>> {
    return await client?.delete(PARTNER_MANAGEMENT.DELETE, params);
  }
}
